import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import "./Learner.css";
import { LearnerForm } from './LearnerForm';
import ViewUtils from "./../../ViewUtils";
import { ViewContainer } from "./../../View.jsx";
import AlertItem from "../../widgets/AlertItem";
import withMenuPermission from "../../widgets/withMenuPermission";


const utils = new ViewUtils();


const learnerRef = React.createRef();
class Learner extends Component {

    state = {
        LearnerDetails: {
            FirstName: "",
            Surname: ""
        },
        title: "",
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' },

                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: 'SAVE', tooltip: 'Save', icon: 'SaveIcon', visible: this.props.menuPermissionItem.Add || this.props.menuPermissionItem.Edit },
                        {
                            contextMenu: [
                                { id: "registrationSkillsProgramme", description: "Skills Programme" },
                                { id: "registrationLearnerships", description: "Learnerships" },
                                { id: "registrationInternships", description: "Internships" },
                                { id: "registrationBursaries", description: "Bursaries" },
                                { id: "registrationAET", description: "AET" },
                                { id: "registrationWIL", description: "WIL" },
                                { id: "registrationLecturer", description: "Lecturer Development" },
                                { id: "registrationArtisan", description: "Artisanship Programme" },
                                { id: "registrationNGONPO", description: "NGOs/NPOs Officials Programme" },
                                { id: "registrationTradeUnion", description: "Trade Union Officials funded for Skills Development Programmes" },
                                { id: "registrationSME", description: "Small and emerging businesses and Cooperatives" },
                                { id: "registrationED", description: "Entrepreneurship Development" },
                                { id: "registrationLEO", description: "Levy Exempt organizations supported" },
                            ],
                            id: 'registrations', label: 'REGISTRATIONS', tooltip: 'Registered Programmes'
                        },
                        {
                            contextMenu: [
                                //{ id: "assessmentsUnitStandard", description: "Unit Standards" },
                                //{ id: "assessmentsQualification", description: "SAQA Qualifications" },
                                { id: "assessmentsSkillsProgramme", description: "Skills Programme" },
                                { id: "assessmentsLearnerships", description: "Learnerships" },
                                //{ id: "assessmentsModuleQualification", description: "QCTO Qualifications" }
                            ],
                            id: 'assessments', label: 'ASSESSMENTS', tooltip: 'Assessed Programmes'
                        },
                        {
                            contextMenu: [
                                //{ id: "achievementsUnitStandards", description: "Unit Standards" },
                                //{ id: "achievementsQualifications", description: "Qualifications" },
                                { id: "achievementsSkillsProgramme", description: "Skills Programme" },
                                { id: "achievementsLearnerships", description: "Learnerships" }
                            ],
                            id: 'achievements', label: 'ACHIEVEMENTS', tooltip: 'Achieved Programmes'
                        },


                        { id: 'crm', label: 'CRM', tooltip: 'Client Relations Management' },
                        //{ id: 'programmeGrants', label: 'PROGRAMME GRANTS', tooltip: 'Learner Programme Grants' },
                    ]
                }
            ]
        }
    };

    handleFormValueChange(values) {
        if (!utils.isNull(values)) {
            this.setState({ LearnerDetails: values });
        }
    }

    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("crm" === buttonId) {
            this.props.history.push({
                pathname: '/learnerCRM',
                state: {
                    LearnerID: this.state.LearnerDetails.ID,
                    LearnerName: `${this.state.LearnerDetails.FirstName} ${this.state.LearnerDetails.Surname}`
                }
            })
        }
        else if ("programmeGrants" === buttonId) {
            this.props.history.push({
                pathname: '/learnergrants',
                state: {
                    LearnerID: this.state.LearnerDetails.ID,
                    LearnerName: `${this.state.LearnerDetails.FirstName} ${this.state.LearnerDetails.Surname}`
                }
            })
        }
    }

    handleToolbarButtonMenuClick(menu) {
        if ("registrationSkillsProgramme" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerSkillsProgrammeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationWIL" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerWILSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationBursaries" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerBursarySearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationLearnerships" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerLearnershipSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationInternships" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerInternshipsSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationAET" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerAETSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationLecturer" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerLecturerDevelopmentSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationArtisan" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerTradeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("registrationNGONPO" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerBSPSkillsProgrammeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname,
                    BSPType: '11.1',
                    BSPDesc: 'NGOs/NPOs Officials'
                }
            })
        }
        else if ("registrationTradeUnion" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerBSPSkillsProgrammeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname,
                    BSPType: '11.2',
                    BSPDesc: 'Trade Union Officials funded for Skills Development Programmes'
                }
            })
        }
        else if ("registrationSME" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerBSPSkillsProgrammeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname,
                    BSPType: '10.1',
                    BSPDesc: 'Small and emerging businesses and Cooperatives'
                }
            })
        }
        else if ("registrationED" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerBSPSkillsProgrammeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname,
                    BSPType: '10.2',
                    BSPDesc: 'Entrepreneurship Development'
                }
            })
        }
        else if ("registrationLEO" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerBSPSkillsProgrammeSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname,
                    BSPType: '22',
                    BSPDesc: 'Levy Exempt organizations supported'
                }
            })
        }  
        else if ("achievementsLearnerships" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerLearnershipAchievements',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("achievementsSkillsProgramme" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerSkillsProgrammeAchievements',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("achievementsQualifications" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerQualificationAchievements',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("achievementsUnitStandards" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerUnitStandardAchievements',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("assessmentsLearnerships" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerLearnershipAssessments',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("assessmentsSkillsProgramme" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerSkillsProgrammeAssessment',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("assessmentsQualification" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerQualificationAssessment',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
        else if ("assessmentsUnitStandard" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerUnitStandardAssessment',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        } else if ("registrationQCTOQualifications" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerModuleQualificationSearch',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        } else if ("assessmentsModuleQualification" === menu.id) {
            this.props.history.push({
                pathname: '/LearnerModuleQualificationAssessment',
                state: {
                    learnerID: this.state.LearnerDetails.ID,
                    learnerNames: this.state.LearnerDetails.FirstName + " " + this.state.LearnerDetails.Surname
                }
            })
        }
    }

    successCallback = () => {

        this.setState({ message: "Learner updated successfully", messageStyle: "SUCCESS" });
    }

    save() {
        let formValue = learnerRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/learnerdetails/UpdateLearner", this.successCallback, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    closeView() {
        this.props.history.push('/learners');
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">

                <p className="breadcrumbs">
                    {"Learner " + (this.state.LearnerDetails.FirstName !== null ? "> " + this.state.LearnerDetails.FirstName + (this.state.LearnerDetails.Surname !== null ? "  " + this.state.LearnerDetails.Surname : "") : "> Add")}
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />

                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title="Learner"
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    buttonMenuClickHandler={(menu) => this.handleToolbarButtonMenuClick(menu)} enabled={false}
                                    config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "80vh", width: "95%" }}>
                                    <LearnerForm ref={learnerRef} id={typeof this.props.location.state !== 'undefined' ? this.props.location.state.selection : null}
                                        valueChangeHandler={(values) => this.handleFormValueChange(values)} editPermission={this.props.menuPermissionItem.Edit} />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(withMenuPermission(Learner));

